"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'app.pagination.pagnation_info': 'Showing {startItem} to {endItem} of {totalItems} entries',
};
